import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=7dfdc824"
import script from "./Locale.vue?vue&type=script&lang=ts"
export * from "./Locale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports